// actions
export const LOAD_THEMES = 'LOAD_THEMES'
export const SYNC_THEMES = 'SYNC_THEMES'

// commit
export const SET_THEMES = 'SET_THEMES'
export const ADD_THEME = 'ADD_THEME'
export const REMOVE_THEME = 'REMOVE_THEME'
export const RESET_THEMES = 'RESET_THEMES'
export const SET_CURRENT_THEME = 'SET_CURRENT_THEME'
export const RESET_CURRENT_THEME = 'RESET_CURRENT_THEME'
